import React, { lazy } from 'react';
// CSS for the carousel
const carouselStyles = `
.carousel-tile{position:relative;isolation:isolate;}
.carousel-thumb{display:block;width:100%;aspect-ratio:9/16;object-fit:cover;position:relative;z-index:1;pointer-events:auto;}
.carousel-overlay{position:absolute;inset:0;pointer-events:none;}
`;
type Item = {
  id: string;
  title: string;
  quote: string;
  posterUrl: string;
  videoUrl: string;
};
export function VideoTestimonials({
  items,
  onPlay
}: {
  items: Item[];
  onPlay: (item: Item) => void;
}) {
  return <section className="w-full bg-gradient-to-br from-[#231232] to-[#1a0d24] py-16 border-b border-[#6805DA]/20" data-id="element-415">
      <style data-id="element-416">{`{carouselStyles}`}</style>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-417">
        <div className="text-center mb-12" data-id="element-418">
          <span className="inline-block px-4 py-1.5 bg-[#FFC501]/10 text-[#FFC501] rounded-full text-sm font-medium mb-4" data-id="element-419">
            HEAR FROM REAL PEOPLE
          </span>
          <h2 className="text-3xl sm:text-4xl font-outfit font-bold mb-6 text-white" data-id="element-420">
            Video Testimonials
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-6" data-id="element-421"></div>
        </div>
        {/* ONE persistent carousel */}
        <div className="
          relative
          grid gap-8
          grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
          [scroll-snap-type:x_mandatory] sm:[scroll-snap-type:unset]
          overflow-x-auto sm:overflow-x-visible pb-6 sm:pb-2
        " data-id="element-422">
          {items.map((item, idx) => <button key={item.id} type="button" onClick={() => onPlay(item)} className="carousel-tile snap-start sm:snap-none text-left group" aria-label={`Play ${item.title}`} data-id="element-423">
              <img className="carousel-thumb rounded-xl transition-transform duration-300 group-hover:scale-[1.02]" src={item.posterUrl} alt={item.title} loading={idx < 2 ? 'eager' : 'lazy'} fetchPriority={idx < 2 ? 'high' : 'auto'} data-id="element-424" />
              <div className="carousel-overlay rounded-xl bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center" data-id="element-425">
                <svg className="w-12 h-12 text-white opacity-80" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-426">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" data-id="element-427" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-428" />
                </svg>
              </div>
              <div className="mt-4" data-id="element-429">
                <h4 className="font-outfit font-bold text-lg text-white mb-2" data-id="element-430">
                  {item.title}
                </h4>
                <p className="text-gray-300 italic" data-id="element-431">"{item.quote}"</p>
              </div>
            </button>)}
        </div>
      </div>
    </section>;
}